import { trackLiglaAutoLineEvent } from "~/utils/functions/ligla"

export default defineNuxtPlugin(() => {
  // クライアントサイドのみで実行

  // 行動ログ取得用に全ページでLiglaイベントを送信
  nextTick(() => {
    const route = useRoute()
    trackLiglaAutoLineEvent("other", "", route.fullPath)
  })
})
